module.exports = __webpack_public_path__ + "static/media/not-live-theme.52f0d03a.png";